import type { ITableColumn } from '../components/TableHeaderGenerator';

export const providerAssignmentColumns: ITableColumn[] = [
  {
    label: 'Provider*',
    accessor: 'provider.first_name',
    textAlign: 'left',
    sortable: true,
  },
  {
    label: 'Clinical Relationship*',
    accessor: 'clinical_relationship',
    sortable: true,
  },
  { label: 'Start Date*', accessor: 'date_start', sortable: true },
  { label: 'End Date', accessor: 'date_end', sortable: true },
  { label: 'Status', accessor: 'status', sortable: false },
  { label: '', accessor: 'actions', sortable: false },
];

export const facilityAssignmentColumns: ITableColumn[] = [
  {
    label: 'Entity Name*',
    accessor: 'facility.label',
    textAlign: 'left',
    sortable: true,
  },
  {
    label: 'Type*',
    accessor: 'assignment_type',
    sortable: true,
  },
  { label: 'Start Date*', accessor: 'date_start', sortable: true },
  { label: 'End Date', accessor: 'date_end', sortable: true },
  { label: 'Status', accessor: 'status', sortable: false },
  { label: '', accessor: 'actions', sortable: false },
];

export const cohortAssignmentColumns: ITableColumn[] = [
  {
    label: 'Cohort Name*',
    accessor: 'cohort.name',
    textAlign: 'left',
    sortable: true,
    width: 3,
  },
  { label: 'Start Date*', accessor: 'date_start', sortable: true },
  { label: 'End Date', accessor: 'date_end', sortable: true },
  { label: '', accessor: 'actions', sortable: false },
];

export const treatmentPlanColumns: ITableColumn[] = [
  {
    label: 'TP ID',
    accessor: 'id',
    textAlign: 'left',
    sortable: true,
    width: 1.2,
  },
  { label: 'BCBA Name', accessor: 'bcba.first_name', sortable: true, width: 3.4 },
  { label: 'TP Status', accessor: 'status_id', sortable: true, width: 1.2 },
  { label: 'Is TP Active?', accessor: 'is_active', sortable: true, width: 2 },
  { label: 'Created date', accessor: 'date_treatment_plan_started', sortable: true },
];

export const policyColumns: ITableColumn[] = [
  { label: 'ID', accessor: 'id', sortable: true, width: 1.1 },
  { label: 'Payor Responsibility', accessor: 'payor_responsibility', sortable: true, width: 1.8 },
  { label: 'Relationship', accessor: 'relationship_to_policyholder', sortable: true, width: 1.8 },
  { label: 'Group number', accessor: 'group_number', sortable: true, width: 1.5 },
  { label: 'Start Date', accessor: 'date_start', sortable: true, width: 1.8 },
  { label: 'End Date', accessor: 'date_end', sortable: true, width: 1.8 },
  { label: 'Payor', accessor: 'payor.label', sortable: true, width: 1.3 },
];

export const clientAssignmentColumns: ITableColumn[] = [
  { label: 'Client ID', accessor: 'client.id', sortable: true, textAlign: 'left', width: 2 },
  { label: 'Name', accessor: 'client.first_name', sortable: true, width: 2.5 },
  { label: 'Clinical relationship', accessor: 'clinical_relationship', sortable: true, width: 2.5 },
  { label: 'Date start', accessor: 'date_start', sortable: true, width: 2.5 },
  { label: 'Date end', accessor: 'date_end', sortable: true, width: 2.5 },
];

export const payorCredentialColumns: ITableColumn[] = [
  {
    label: 'Provider',
    accessor: 'provider.first_name',
    sortable: true,
    textAlign: 'left',
    width: 2,
  },
  { label: 'Payor', accessor: 'payor.label', sortable: true, width: 4 },
  { label: 'Date start', accessor: 'date_start', sortable: true, width: 2 },
  { label: 'Date end', accessor: 'date_end', sortable: true, width: 2 },
];
